import { render } from "./ProjectMigration.vue?vue&type=template&id=b4b560ec&scoped=true&ts=true"
import script from "./ProjectMigration.vue?vue&type=script&lang=ts"
export * from "./ProjectMigration.vue?vue&type=script&lang=ts"

import "./ProjectMigration.vue?vue&type=style&index=0&id=b4b560ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b560ec"]])

export default __exports__